import { render } from "./NoticeItem.vue?vue&type=template&id=55536704&scoped=true"
import script from "./NoticeItem.vue?vue&type=script&lang=js"
export * from "./NoticeItem.vue?vue&type=script&lang=js"

import "./NoticeItem.vue?vue&type=style&index=0&id=55536704&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55536704"]])

export default __exports__